import {combine, forward, merge, sample} from 'effector';

import {RestError, showRestError} from 'core/errors';
import {initFiltersList, initSortingsList} from 'core/hooks/grid2.0';
import {mapFilters, mapSortings} from 'utils/grid-mappers';

import {
    clearDataCacheFx,
    data$,
    fetchDataFx,
    filters$,
    filtersChanged,
    filtersReset,
    filtersSubmit,
    Gate,
    listStateChanged,
    pageIncremented,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    search$,
    searchChanged,
    sortings$,
    sortingsChanged,
    sortingsReset,
    stateReset,
    updOnly$,
} from './index';

data$
    .on(fetchDataFx.done, (state, {result}) => ({
        content: state ? state.content.concat(result.content) : result.content,
        hasNext: result.hasNext,
    }))
    .reset(sortingsChanged, filtersChanged, Gate.close);
pageNumber$.reset(
    filtersSubmit,
    filtersReset,
    sortingsChanged,
    sortingsReset,
    stateReset,
    searchChanged,
);
pageSize$.reset(stateReset);

initFiltersList(filters$, filtersChanged, filtersReset, stateReset);
initSortingsList(sortings$, sortingsChanged, sortingsReset, stateReset);

sample({
    clock: pageIncremented,
    source: pageNumber$.map((state) => state + 1),
    target: pageNumberChanged,
});

forward({
    from: merge([
        Gate.close,
        pageSizeChanged,
        filtersSubmit,
        filtersReset,
        sortingsChanged,
        sortingsReset,
    ]),
    to: clearDataCacheFx,
});

sample({
    clock: merge([Gate.open, listStateChanged, searchChanged]),
    source: combine({
        pageNumber: pageNumber$,
        pageSize: pageSize$,
        filters: filters$,
        sortings: sortings$,
        search: search$,
        updOnly: updOnly$,
    }),
    fn: ({pageNumber, pageSize, filters, sortings, search, updOnly}) => ({
        paging: {
            pageNumber,
            pageSize,
        },
        filters: mapFilters(filters),
        sortings: mapSortings(sortings),
        search,
        updOnly,
    }),
    target: fetchDataFx,
});

fetchDataFx.fail.watch(({error}) => showRestError(error as RestError));
